module.exports = __webpack_public_path__ + "img/mascot-query-string.bb90db26.svg";